import React from 'react';
import { useOrg } from '../context/OrgContext';

const ContactPage: React.FC = () => {
  const org = useOrg();

  const addressLines = [
    [org?.address_line_1, org?.address_line_2].filter(Boolean).join(', '),
    [org?.city, org?.state, org?.pincode].filter(Boolean).join(', '),
  ].filter(Boolean);

  return (
    <div className="contact-page">
      <div className="contact-card">
        <h1 className="contact-card__title">Contact Us</h1>
        <div className="contact-card__body">
          <div className="contact-row">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
            <div>
              <p className="contact-row__label">Organisation</p>
              <p className="contact-row__value">{org?.org_name || '—'}</p>
            </div>
          </div>

          {org?.contact_person_name && (
            <div className="contact-row">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              <div>
                <p className="contact-row__label">Contact Person</p>
                <p className="contact-row__value">{org.contact_person_name}</p>
              </div>
            </div>
          )}

          {org?.mobile && (
            <div className="contact-row">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.15 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.09 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 16l.92.92z"/></svg>
              <div>
                <p className="contact-row__label">Phone</p>
                <a href={`tel:${org.mobile}`} className="contact-row__value contact-row__link">{org.mobile}</a>
              </div>
            </div>
          )}

          {org?.email_id && (
            <div className="contact-row">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              <div>
                <p className="contact-row__label">Email</p>
                <a href={`mailto:${org.email_id}`} className="contact-row__value contact-row__link">{org.email_id}</a>
              </div>
            </div>
          )}

          {org?.upi_id && (
            <div className="contact-row">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>
              <div>
                <p className="contact-row__label">UPI / Payment ID</p>
                <p className="contact-row__value">{org.upi_id}</p>
              </div>
            </div>
          )}

          {addressLines.length > 0 && (
            <div className="contact-row">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
              <div>
                <p className="contact-row__label">Address</p>
                <p className="contact-row__value">
                  {addressLines.map((line, i) => (
                    <span key={i}>{line}{i < addressLines.length - 1 && <br />}</span>
                  ))}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
